import { useAppSelector } from '../useAppSelector';
import * as lookupSlice from '../../data/lookup.slice';

export const useClientVertical = (verticalBC: string | undefined): string => {
  const verticals = useAppSelector(lookupSlice.selectClientVerticals);
  const vertical = verticals.find((s) => s.clientVerticalBC === verticalBC);
  return vertical ? vertical.clientVerticalName : '';
};
